import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";

const SimTabs = ({ data = [], children, nav_wrapper_class, defaultActiveKey, setActiveTab = null, small = false }) => {
  const [activeKey, setActiveKey] = useState("");
  const handleClick = (key) => {
    setActiveKey(key);
    if (setActiveTab) {
      setActiveTab(key);
    }
  };

  useEffect(() => {
    setActiveKey(defaultActiveKey);
  }, [defaultActiveKey]);

  return (
    <Tab.Container activeKey={activeKey} onSelect={handleClick}>
      <div className={nav_wrapper_class}>
        <Nav variant="pills" className="tabfull">
          {data?.map((item) => (
            <Nav.Item className={small ? "small-tab" : ""} key={item?.key}>
              <Nav.Link eventKey={item?.key}>
                {item?.navItem.title}
                {item?.navItem?.count && <span className="numbercount">{item.navItem.count}</span>}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        {children}
      </div>

      <Tab.Content>
        {data?.map((item) => (
          <Tab.Pane eventKey={item?.key} key={item?.key}>
            {item?.content?.component()}
          </Tab.Pane>
        ))}
      </Tab.Content>
    </Tab.Container>
  );
};

export default SimTabs;
